import React, {useEffect, useState} from "react";
import {Col, Row} from "react-bootstrap";
import Form from "react-bootstrap/Form";
import {useIntl} from "react-intl";

export const DATE_FILTER_ALL_DATES = -1;
export const DATE_FILTER_SIX_MONTHS = 6;
export const DATE_FILTER_TWELVE_MONTHS = 12;
export const DATE_FILTER_TWENTYFOUR_MONTHS = 24;

interface RadioMonthFilterProps {
    filterByDate: (filterValue: number | undefined) => void;
}

interface DateFilterOption {
    value: number
    label: string
}

/**
 * Komponente um einen globalen React-Table Filter zur Verfügung zu stellen, mit dem Zeilen gefiltert werden können,
 * sodass nur Einträge dargestellt werden, die jünger als eine per Radiobutton ausgewählte Schranke sind.
 *
 * @param filterByDate - Filtermethode welche ausgeführt wird, wenn sich der Filter ändert
 * @constructor
 */
const RadioMonthFilter: ({filterByDate}: RadioMonthFilterProps) => JSX.Element = ({filterByDate}: RadioMonthFilterProps) => {
    const intl = useIntl();
    const dateFilterOptions: DateFilterOption[] = [
        {
            value: DATE_FILTER_SIX_MONTHS,
            label: intl.formatMessage({id: 'myarea.listing.global.filter.date.months.six'})
        },
        {
            value: DATE_FILTER_TWELVE_MONTHS,
            label: intl.formatMessage({id: 'myarea.listing.global.filter.date.months.twelve'})
        },
        {
            value: DATE_FILTER_TWENTYFOUR_MONTHS,
            label: intl.formatMessage({id: 'myarea.listing.global.filter.date.months.twentyfour'})
        },
        {value: DATE_FILTER_ALL_DATES, label: intl.formatMessage({id: 'myarea.listing.global.filter.date.all'})},
    ]
    const [dateFilter, setDateFilter] = useState<DateFilterOption | undefined>(
        dateFilterOptions.find((option) => option.value = DATE_FILTER_SIX_MONTHS)
    );

    useEffect(() => {
        filterByDate(dateFilter?.value);
    }, [dateFilter]);

    return (
        <Row>
            {dateFilterOptions.map(({value, label}, index) => (
                <Col sm={12} key={index}>
                    <Form.Check type="radio"
                                id={`dateFilter-${index}`}
                                label={label}
                                value={value}
                                onChange={(e) => setDateFilter(dateFilterOptions.find((option) => option.value = value))}
                                checked={dateFilter?.value === value}
                    />
                </Col>
            ))}
        </Row>
    );
}

export default RadioMonthFilter;